import { Table } from "rsuite";
let { Pagination } = Table;
 
export default function DynamicTablePagination(props) {
     
  return <Pagination {...props} />;
}
